import { ListHeader } from 'components/molecules/ListHeader';
import { FC } from 'react';

export const CustomerListHeader: FC = () => (
  <ListHeader
    columns={['顧客 ID', '顧客名', '顧客詳細', 'ステータス', '顧客環境']}
    templateColumns="1fr 2fr 3fr 1fr 1fr"
  />
);
